<template>
    <div class="container-fluid" id="about" v-if="show">
        <div class="eyecatch">
            <img src="/img/about/04.jpg" alt="アイキャッチ・小説を書く" class="img-fluid mx-auto d-block about" />
        </div>
        <div class="container mincho">
            <links></links>
            <h2 class="text-center" id="instruction">ユーザー登録して小説を執筆するまでの流れ</h2>
            <div class="row mt-5">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/a01.png'" alt="ユーザー登録" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <h4>ユーザー登録</h4>
                    <p>
                        <a href="/register">ユーザー登録</a>ページから、ユーザー登録してください。
                    </p>
                    <p>
                        貸し本棚で表示するお名前とそのふりがな、メールアドレスとパスワードを入力して登録してください。
                        パスワードは<b>8桁以上</b>であることが必須となっています。
                    </p>
                    <h5>連携ログイン</h5>
                    <p>
                        メールアドレスを使ったユーザー登録が面倒な場合、Googleアカウントと連携することで瞬時にユーザー登録することもできます。
                        Googleにログインした状態で、Googleアカウントで登録ボタンをクリックすると、
                        それでユーザー登録が完了します。
                        （複数アカウントでログインしているときは、どのアカウントで連携するか選択画面が表示されます）。
                    </p>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/a02.png'" alt="メールの確認" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <h4>メールの確認</h4>
                    <p>
                        <b>メールアドレスとパスワードでユーザー登録を行った場合、</b>
                        登録したメールアドレスに確認メールが送信されます。
                        このメールを開いて「メールアドレスを確認」ボタンをクリックしてください。
                        それでメールアドレスの認証が完了します。
                        この作業はユーザー登録後、１度だけ必要となります。
                    </p>
                    <p>
                        このメールアドレスの確認作業を行うと、この後の「サブドメインの登録」が行えます。
                        サブドメインの登録を行うと、ご自身の専用本棚を持つことができます。
                    </p>
                    <p>
                        <b>Googleアカウント連携でユーザー登録を行った場合は、</b>
                        この作業は必要ありません。
                    </p>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/a03.png'" alt="ドメインの登録" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <h4>サブドメインの登録</h4>
                    <p>
                        専用の本棚を持つためには、サブドメインの登録が必要です。
                        「とりあえず作品投稿を試してみたい」という方は、この手順を飛ばして「小説を新規追加する」へ進んでください。
                    </p>
                    <p>
                        マイページ＞アカウント情報から、サブドメインの設定を行います。
                        サブドメインは32文字以内の半角英数字、ハイフンのみを使用できます。
                        <b>アンダースコア(_)は使用できません。</b>
                    </p>
                    <p>
                        ここで決めたサブドメインにあなたの本棚が表示されます。
                        例えば「example」というサブドメインを取得した場合、
                        <code>
                            https://example{{$store.state.base_domain}}/
                        </code>
                        があなたの本棚のトップページのURLとなります。
                    </p>
                    <p class="text-danger">
                        一度決定したサブドメインは変更できません。
                    </p>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-md-7">
                    <img v-lazy="'/img/about/a04.png'" alt="小説を新規追加" class="img-fluid img-desc mx-auto d-block" />
                </div>
                <div class="col-md-5">
                    <h4>小説を新規追加する</h4>
                    <p>
                        マイページ＞小説の新規投稿から小説を新規追加します。
                    </p>
                    <p>
                        小説のタイトル、紹介文を入力し、長編・短編を選択して保存すれば、
                        すぐに第１話の入力画面に遷移します。
                        入力した小説情報は後から変更できます。
                    </p>
                    <p>
                        本文を記述し、「公開する」ボタンから公開日時を選択すれば、
                        あなたの小説は、あなたの本棚上で公開されます。
                    </p>
                </div>
            </div>
            <div class="mt-5">
                <links></links>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.eyecatch {
    background-color: #D8DED0;
}
.about {
    max-height: 640px;
}
.desc {
    font-size: 1.1rem;
    margin-bottom: 2.5rem;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.caption {
    margin: 3rem 0 .8rem;
    padding: .5rem 0;
    border-bottom: 1px dashed #ddd;
}
.img-desc {
    border: 1px solid #ddd;
    border-radius: .2rem;
}
.img-tips {
    width: 350px;
    height: 350px;
}
.img-icon {
    object-fit: cover;
    width: 64px;
    height: 64px;
}
.icon-column {
    max-width: 64px;
}
.small-caption {
    font-weight: bold;
    text-align: center;
    margin-top: 2rem;
}
#about {
    padding-right: 0px;
    padding-left: 0px;
    h2 {
        margin-top: 5rem;
        margin-bottom: 1rem;
    }
}
</style>

<script>
import links from "./links";
export default {
    components: {
        links
    },
    data() {
        return {
            show: true
        }
    },
    mounted() {
        this.useHead({
            title: "ユーザー登録して執筆するまでの流れ | 貸し本棚",
            link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ]
        });
    }
}
</script>